<template>
	<div
		class="container__kpi"
		:title="rawValue || null"
	>
		<div
			v-if="hasValue"
			class="container__kpi__info"
		>
			<label class="container__kpi__info__value">{{ value }}</label>
			<!-- Sem slot, a descricao e o texto simples da prop. Com slot, quem usa o
			     KPI coloca um controle no lugar (ex: seletor de variante do IMA), que
			     nao pode ficar dentro de um <label>. -->
			<div
				v-if="$scopedSlots.description"
				class="container__kpi__info__description"
			>
				<slot name="description" />
			</div>
			<label
				v-else
				class="container__kpi__info__description"
				>{{ description }}</label
			>
		</div>
		<div
			v-else
			class="container__kpi_placeholder"
		>
			<Loading />
		</div>
	</div>
</template>

<script>
import Loading from '../../components/Loading/Loading'

export default {
	components: { Loading },
	props: {
		value: { type: [String, Number] },
		description: String,
		rawValue: { type: String, default: '' },
	},
	computed: {
		/**
		 * Verifica se o componente possui valor
		 */
		hasValue() {
			return this.value && this.description
		},
	},
}
</script>

<style scped>
.container__kpi {
	min-height: 5rem;
	width: 40%;
	border-radius: 5px;
	background-color: var(--color-background);
	margin: 0.5rem;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	color: rgb(var(--color-primary));
	box-shadow: 0px 9px 15px -15px rgba(0, 0, 0, 1);
}

.container__kpi__info {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.container__kpi__info__value {
	font-weight: 700;
	font-size: 1rem;
	text-align: center;
}

.container__kpi__info__description {
	font-size: 0.75rem;
	text-align: center;
}

@media screen and (min-width: 992px) {
	.container__kpi {
		width: 11rem;
		justify-content: space-around;
	}

	.container__kpi__info__value {
		font-weight: 700;
		font-size: 1.5rem;
	}
}
</style>
